import { Module } from 'wrapper6'
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'
import ObjectFitClass from '../utils/_object-fit'

const $ = jQuery

export default class Sliders extends Module {
  ready (app) {
    this.coverSliders = document.querySelectorAll('.mtt-standard-cover')
    this.textImageSliders = document.querySelectorAll('.mtt-text-image')

    if (this.coverSliders.length) {
      for (let i = 0; i < this.coverSliders.length; i++) {
        const sliderWrapper = this.coverSliders[i]

        new Slider(sliderWrapper)
      }
    }

    if (this.textImageSliders.length) {
      for (let i = 0; i < this.textImageSliders.length; i++) {
        const sliderWrapper = this.textImageSliders[i]

        new Slider(sliderWrapper)
      }
    }
  }
}

class Slider {
  constructor (sliderWrapper) {
    this.sliderWrapper = sliderWrapper
    this.addSlider()
    new ObjectFitClass()
  }

  addSlider () {
    this.slider = this.sliderWrapper.querySelector('.swiper-container')

    let options = {
      loop: false,
      autoplay: {
        delay: 5000
      },
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      lazy: {
        loadPrevNext: true,
        checkInView: false
      },
      allowTouchMove: false,
      watchSlidesVisibility: true,
    }

    if (!this.sliderWrapper.classList.contains('no-navigation')) {
      const nextArrow = this.sliderWrapper.querySelector('.mtt-swiper-button-next')
      const prevArrow = this.sliderWrapper.querySelector('.mtt-swiper-button-prev')
      options.navigation = {
        nextEl: nextArrow,
        prevEl: prevArrow
      }
    }

    const swiper = new Swiper(this.slider, options)
  }
}
